import React from "react";

const moment = require('moment-timezone');

import BaseComponent from "../../baseComponent.js";
import {defaultDateFormat, defaultDateTimeFormat, defaultTimeFormat} from "../../../core/constants/defaultValues";
import InternalEvent from "../../../core/constants/internalEvent";
import DashboardService from "../../../core/services/dashboardService";
import {variableTypes} from "./selection-contorl/constants";
import {DateOnlyPicker, DateTimePicker, TimePicker} from "./selection-contorl/dateTimePicker.jsx";
import styles from "./styles.scss";


export class InputControl extends BaseComponent {
  constructor(props) {
    super(props);
    const variable = DashboardService.getCurrentDashboardVariableById(this.props.metaData.variable.id);
    this.state = {
      variable: variable,
      showLabel: this.props.showLabel
    };
  }

  componentDidMount() {
    this.dashboardChangeSubscription = DashboardService.dashboardStream.subscribe(d => {
      const variable = DashboardService.getCurrentDashboardVariableById(this.props.metaData.variable.id);
      if (variable) {
        this.setState({
          variable: this.deepCopy(variable)
        });
      }
    });
    document.body.addEventListener('click', this.bodyClickEventHandler);
  }

  componentWillUnmount() {
    this.dashboardChangeSubscription.unsubscribe();
    document.body.removeEventListener('click', this.bodyClickEventHandler);
  }

  openPicker(refName) {
    this.props.onPickerOpen();
    $(this.refs[refName]).css({
      display: "block"
    });
    if (refName === "datePickerWrapper") {
      setTimeout(() => {
        this.refs.dateOnlyPicker.open();
      }, 10);
    }
  }

  hidePicker(refName) {
    $(this.refs[refName]).hide();
  }

  bodyClickEventHandler(event) {
    if ($(event.target).parents(".datePickerWrapper").length ||
      $(event.target).parents(".dateTimePickerWrapper").length ||
      $(event.target).parents(".timePickerWrapper").length ||
      $(event.target).parents(".react-datepicker").length) {
    } else {
      $(this.refs.datePickerWrapper).css("display", "none");
      $(this.refs.dateTimePickerWrapper).css("display", "none");
      $(this.refs.timePickerWrapper).css("display", "none");
      this.publishChangeEvent();
      this.props.onPickerClose();
    }
  }

  publishChangeEvent() {
    if (this.shouldPublishVariableChangeEvent) {
      this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, [this.state.variable]);
      this.shouldPublishVariableChangeEvent = false;
    }
  }

  /**
   * A change event handler for Time, DateTime, and DateOnly picker.
   * @param date
   * @param time
   * @param timezone
   */
  handleDateTimeChange(date, time, timezone, fireChangeImmediately) {
    const state = this.copyState();
    const variable = state.variable;
    let originalDate = moment(this.state.variable.value);
    let newDateStr, newDate, changes = {};
    if (date) {
      newDateStr = date.format("YYYY-MM-DDT") + originalDate.format("HH:mm:ss.SSS") + originalDate.format("Z");
      newDate = moment.tz(newDateStr, variable.timezone);
    }
    if (time) {
      originalDate = moment.tz(variable.value, variable.timezone);
      const timeStr = this.replaceAt(time, 8, ".");
      newDateStr = originalDate.format("YYYY-MM-DDT") + timeStr + originalDate.format("Z");
      newDate = moment.tz(newDateStr, variable.timezone);
    }
    if (timezone) {
      originalDate = moment.tz(variable.value, variable.timezone);
      newDateStr = originalDate.format("YYYY-MM-DDTHH:mm:ss.SSS");
      newDate = moment.tz(newDateStr, timezone);
      variable.timezone = timezone;
    }
    variable.value = newDate.toISOString();

    this.setState(state);
    this.shouldPublishVariableChangeEvent = true;

    if (fireChangeImmediately) {
      this.shouldPublishVariableChangeEvent = false;
      this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, [state.variable]);
      this.props.onPickerClose();
    }
  }

  replaceAt(string, index, replacement) {
    return string.substr(0, index) + replacement + string.substr(index + replacement.length);
  };


  handleChange(value) {
    const state = this.copyState();
    if (this.state.variable.type === variableTypes.NUMBER) {
      value = parseFloat(value);
      if (isNaN(value)) {
        value = "";
      }
    }
    state.variable.value = value;
    this.setState(state);
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, [state.variable]);
    }, 800);
  }

  renderInput() {
    const variable = this.state.variable;
    const title = this.props.metaData.title;

    switch (variable.type) {
      case variableTypes.TIME: {
        const time = moment.tz(variable.value, variable.timezone);
        return <div className={["input-control", styles.inputControl].join(" ")}>
          {this.props.showLabel ? <div className={styles.floatLabel}>{title}</div> : null}
          <div className={styles.inputValue} onClick={() => this.openPicker("timePickerWrapper")}>
            {time.format(variable.dateTimeFormat || defaultTimeFormat)}</div>
          <div className={["timePickerWrapper", styles.timePickerWrapper].join(" ")} ref="timePickerWrapper">
            <TimePicker date={time}
                        timezone={variable.timezone}
                        onTimeChange={this.handleDateTimeChange}/>
            <div className={styles.backdrop} onClick={() => this.hidePicker("timePickerWrapper")}/>
          </div>
        </div>;
      }
      case variableTypes.DATETIME: {
        const dateTime = moment.tz(variable.value, variable.timezone);
        return <div className={["input-control", styles.inputControl].join(" ")}>
          {this.props.showLabel ? <div className={styles.floatLabel}>{title}</div> : null}
          <div className={styles.inputValue} onClick={() => this.openPicker("dateTimePickerWrapper")}>
            {dateTime.format(variable.dateTimeFormat || defaultDateTimeFormat)}</div>
          <div className={["dateTimePickerWrapper", styles.dateTimePickerWrapper].join(" ")}
               ref="dateTimePickerWrapper">
            <DateTimePicker date={dateTime}
                            ref="dateTimePicker"
                            timezone={variable.timezone}
                            format={variable.dateTimeFormat || defaultDateTimeFormat}
                            onDateChange={this.handleDateTimeChange}/>
            <div className={styles.backdrop} onClick={() => this.hidePicker("dateTimePickerWrapper")}/>
          </div>
        </div>;
      }
      case variableTypes.DATE: {
        const date = moment(variable.value);
        return <div className={["input-control", styles.inputControl].join(" ")}>
          {this.props.showLabel ? <div className={styles.floatLabel}>{title}</div> : null}
          <div className={styles.inputValue} onClick={() => this.openPicker("datePickerWrapper")}>
            {date.format(variable.dateTimeFormat || defaultDateFormat)}</div>
          <div className={["datePickerWrapper", styles.datePickerWrapper].join(" ")} ref="datePickerWrapper">
            <DateOnlyPicker ref="dateOnlyPicker"
                            date={date}
                            format={variable.dateTimeFormat || defaultDateFormat}
                            onBlur={() => this.hidePicker("datePickerWrapper")}
                            onDateChange={(date) => this.handleDateTimeChange(date, null, null, true)}/>
            <div className={styles.backdrop}/>
          </div>
        </div>;
      }
      default:
        return <div className="input-field col s12" style={{marginTop: 0, padding: 0}}>
          <input value={this.state.variable.value} id={variable.id} type="text"
                 onChange={(e) => this.handleChange(e.target.value)}/>
          {this.props.showLabel ?
            <label htmlFor={variable.id} style={{left: 0}}>{this.props.metaData.title}</label> : null}
        </div>;
    }
  }

  render() {
    return (
      this.renderInput()
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/inputControl.jsx